import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ProjectCard from '../ProjectCard/ProjectCard';
import './Projects.css';
import spinner from '../../../images/spinner.gif';

const Projects = () => {
        const [projects, setProjects] = useState([]);
        // Load All Projects:
        useEffect(() => {
                fetch('./projects.json')
                        .then(res => res.json())
                        .then(data => setProjects(data))
        }, []);

        const history = useHistory();
        const moreProjects = () => {
                history.push('/projects')
        }

        // Spinner:
        if (!projects.length) {
                return <div className="spinner">
                        <div className="loading d-flex justify-content-center align-items-center pt-5">
                                <img className="img-fluid mt-5" src={spinner} alt="" />
                        </div>
                </div>
        }
        return (
                <div className="projects">
                        <div className="pt-5 project-headline">
                                <marquee>
                                        <h1 className="text-center text-white fw-bold text-decoration-underline mb-5 mt-5 project-headline"
                                        >Some Of My<span className="brand-color"> Projects</span> </h1>
                                </marquee>
                        </div>
                        {
                                projects.slice(0, 3).map(project => <ProjectCard
                                        project={project}
                                        key={project.id}
                                >
                                </ProjectCard>)
                        }
                        <div className="text-center mt-5" data-aos="zoom-in-up"
                                data-aos-offset="300">
                                <button onClick={moreProjects} className="btn brand-btn btn-lg fw-bold">More Projects</button>
                        </div>
                </div>
        );
};

export default Projects;